<div [formGroup]="form">
  <div formGroupName="citizenshipResidencyValidation">
    <p class="text-sm" i18n="@@support.citizenshipResidencyValidation.note">If you registered on BitOasis with a different number from the countries below, you can validate your residency/citizenship to fully use our services here.<br>UAE, Saudi Arabia, Kuwait, Bahrain, Oman, Morocco, Egypt, Jordan.</p>

    <file-uploader [maxSize]="1024 * 5" [allowedTypes]="['png', 'jpg', 'jpeg', 'pdf']" (select)="onFileSelect($event)" (remove)="onFileRemove()"
      class="d-block mb-3">
      <input #file type="file" class="input">
      <ng-template #placeholder>
        <img src="assets/images/icons/upload-passport.svg" alt="">
        <div class="text-primary pt-2 text-sm" i18n="@@support.citizenshipResidencyValidation.passportOrResidency">Passport or Residency visa copy</div>
      </ng-template>
    </file-uploader>

    <form-field class="front textarea" label="Ticket Message" i18n-label="@@support.citizenshipResidencyValidation.message.label">
      <textarea formControlName="message" placeholder="Enter your ticket message" rows="5" i18n-placeholder="@@support.citizenshipResidencyValidation.message.placeholder"></textarea>
    </form-field>
  </div>
</div>
